import { render, staticRenderFns } from "./Internalchat.vue?vue&type=template&id=15cf80b6&scoped=true"
import script from "./Internalchat.vue?vue&type=script&lang=js"
export * from "./Internalchat.vue?vue&type=script&lang=js"
import style0 from "./Internalchat.vue?vue&type=style&index=0&id=15cf80b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf80b6",
  null
  
)

export default component.exports